module.exports = __webpack_public_path__ + "img/birthday-icon.8beb1036.svg";